import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, watch } from 'vue';
import store from '@/store';
import ModalImportSearch from '../../search/ModalImportSearch.vue';
import ModalImportList from '../../list/ModalImportList.vue';
import { Item } from '../../../types';


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalImportTabsTemplates',
  emits: ["template-selected"],
  setup(__props, { emit }: { emit: ({
    (event: 'template-selected'): void;
}), expose: any, slots: any, attrs: any }) {



const isLoading = ref(true);
const currentPage = ref(1);
const perPage = 5;
const searchText = ref('');

const templates = computed(() => store.state.storeLayersModal!.templates);
const totalTemplates = computed(() => store.state.storeLayersModal!.totalTemplates);

const items = computed(() => {
    return templates.value.map((template) => ({
        thumb: template.thumbnailPath,
        name: template.name,
        id: template.id
    }));
});

watch(currentPage, () => {
    fetchTemplates();
});

onMounted(() => {
    fetchTemplates();
});

const updateSearchText = async (value: string) => {
    searchText.value = value;
    await fetchTemplates();
};

const fetchTemplates = async () => {
    try {
        isLoading.value = true;
        await store.dispatch('storeLayersModal/getTemplates', {
            from: (currentPage.value - 1) * perPage,
            pageSize: perPage,
            sortMode: 'ASC',
            sortBy: 'ModifiedDate',
            searchString: searchText.value,
            deleted: false
        });
    } finally {
        isLoading.value = false;
    }
};

const itemSelected = async (item: Item) => {
    try {
        isLoading.value = true;
        const template = templates.value.find((template) => template.id === item.id);
        if (template) {
            await store.dispatch('storeLayersModal/getTemplate', template.id);
            store.dispatch('storeLayersModal/setSelectedItem', item);
            emit('template-selected');
        }
    } finally {
        isLoading.value = false;
    }
};

return { __sfc: true,emit, isLoading, currentPage, perPage, searchText, templates, totalTemplates, items, updateSearchText, fetchTemplates, itemSelected, ModalImportSearch, ModalImportList }
}

})